// utils/cropImage.ts
interface PixelCrop {
    x: number;
    y: number;
    width: number;
    height: number;
}


export const getCroppedImg = async (
    imageSrc: string,
    pixelCrop: PixelCrop,
    outputSize = 1024
): Promise<string | null> => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (!ctx) return null;

    canvas.width = outputSize;
    canvas.height = outputSize;

    ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        outputSize,
        outputSize
    );

    return canvas.toDataURL('image/jpeg');
};

const createImage = (url: string): Promise<HTMLImageElement> =>
    new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = url;
    });

export function dataURLtoBlob(dataURL: string): Blob {
    const [meta, content] = dataURL.split(',');
    const mime = meta.match(/:(.*?);/)?.[1] || 'image/jpeg';
    const byteString = atob(content);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mime });
}
